import { css } from '@emotion/react';
import theme from 'shared/styles/themes';

export default css({
  '&.account-manager-settings': {
    marginBottom: theme.space[6],
  },
});
